export default "__VITE_ASSET__DuirsOrl__"